<template>
  <pt-integral-task-detail class="pt-integral-task-detail__withData" v-loading="loading" :data="currentData"></pt-integral-task-detail>
</template>

<script>
import PtIntegralTaskDetail from './index'
export default {
  name: 'pt-integral-task-detail__withData',
  components: {
    'pt-integral-task-detail': PtIntegralTaskDetail
  },
  data () {
    return {
      loading: false,
      currentData: {}
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$store.dispatch('getIntegralTask', this.$route.params.id).then(data => {
        this.loading = false
        this.currentData = data
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
